export const phoneNum = {
  label: "(877) 327-9309",
  value: "+18773279309"
};
